var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVpnEncrIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.875C7.49888 12.6751 7.90276 14.4524 8.68172 16.0753C9.46069 17.6981 10.5948 19.1249 12 20.25C13.4069 19.1259 14.5428 17.6995 15.3234 16.0766C16.1041 14.4537 16.5094 12.6759 16.5094 10.875C16.5094 9.07412 16.1041 7.29633 15.3234 5.67343C14.5428 4.05053 13.4069 2.62414 12 1.5C10.5948 2.62507 9.46069 4.05188 8.68172 5.67473C7.90276 7.29757 7.49888 9.07488 7.5 10.875Z",
    fill: "#FFD956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83499 12C9.83469 12.8645 10.0292 13.718 10.404 14.4971C10.7788 15.2761 11.3243 15.9607 12 16.5C12.6753 15.9604 13.2205 15.2757 13.5952 14.4968C13.9699 13.7178 14.1645 12.8644 14.1645 12C14.1645 11.1356 13.9699 10.2822 13.5952 9.50325C13.2205 8.72426 12.6753 8.03959 12 7.5C11.3243 8.03929 10.7788 8.72389 10.404 9.50294C10.0292 10.282 9.83469 11.1355 9.83499 12Z",
    fill: "url(#paint0_linear_1995_5864)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1553 11.33C14.9446 12.1663 14.9252 13.0393 15.0983 13.8841C15.2714 14.729 15.6327 15.524 16.1553 16.21C16.9405 15.8525 17.6352 15.3228 18.1877 14.6601C18.7402 13.9975 19.1363 13.2189 19.3467 12.3821C19.5571 11.5454 19.5763 10.672 19.403 9.82681C19.2296 8.98163 18.8681 8.18634 18.3453 7.5C17.5598 7.85754 16.8651 8.38757 16.3128 9.05067C15.7605 9.71377 15.3649 10.4929 15.1553 11.33Z",
    fill: "#FFD956"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84534 11.33C9.05596 12.1663 9.07543 13.0393 8.90231 13.8841C8.72918 14.729 8.36791 15.524 7.84534 16.21C7.06008 15.8525 6.36542 15.3228 5.81292 14.6601C5.26042 13.9975 4.86427 13.2189 4.65389 12.3821C4.4435 11.5454 4.42428 10.672 4.59765 9.82681C4.77102 8.98163 5.13253 8.18634 5.65534 7.5C6.44077 7.85754 7.13547 8.38757 7.68777 9.05067C8.24006 9.71377 8.63573 10.4929 8.84534 11.33Z",
    fill: "#FFD956"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33501 6.33C4.84035 6.33 5.25001 5.92034 5.25001 5.415C5.25001 4.90966 4.84035 4.5 4.33501 4.5C3.82967 4.5 3.42001 4.90966 3.42001 5.415C3.42001 5.92034 3.82967 6.33 4.33501 6.33Z",
    fill: "#FFD956"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36001 6.09996C6.4677 6.09996 6.55501 6.01266 6.55501 5.90496C6.55501 5.79727 6.4677 5.70996 6.36001 5.70996C6.25231 5.70996 6.16501 5.79727 6.16501 5.90496C6.16501 6.01266 6.25231 6.09996 6.36001 6.09996Z",
    fill: "#FFD956"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 4.95996C7.44404 4.95996 7.5 4.904 7.5 4.83496C7.5 4.76593 7.44404 4.70996 7.375 4.70996C7.30596 4.70996 7.25 4.76593 7.25 4.83496C7.25 4.904 7.30596 4.95996 7.375 4.95996Z",
    fill: "#FFD956"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 6C17.8321 6 18 5.83211 18 5.625C18 5.41789 17.8321 5.25 17.625 5.25C17.4179 5.25 17.25 5.41789 17.25 5.625C17.25 5.83211 17.4179 6 17.625 6Z",
    fill: "#FFD956"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2497 7.14C17.3574 7.14 17.4447 7.0527 17.4447 6.945C17.4447 6.8373 17.3574 6.75 17.2497 6.75C17.142 6.75 17.0547 6.8373 17.0547 6.945C17.0547 7.0527 17.142 7.14 17.2497 7.14Z",
    fill: "#FFD956"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.85 6.325C20.0433 6.325 20.2 6.1683 20.2 5.975C20.2 5.7817 20.0433 5.625 19.85 5.625C19.6567 5.625 19.5 5.7817 19.5 5.975C19.5 6.1683 19.6567 6.325 19.85 6.325Z",
    fill: "#FFD956"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.415 8.08C20.5061 8.08 20.58 8.00613 20.58 7.915C20.58 7.82387 20.5061 7.75 20.415 7.75C20.3239 7.75 20.25 7.82387 20.25 7.915C20.25 8.00613 20.3239 8.08 20.415 8.08Z",
    fill: "#FFD956"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65499 3.12504C6.81515 3.12504 6.94499 2.99521 6.94499 2.83504C6.94499 2.67488 6.81515 2.54504 6.65499 2.54504C6.49483 2.54504 6.36499 2.67488 6.36499 2.83504C6.36499 2.99521 6.49483 3.12504 6.65499 3.12504Z",
    fill: "#FFD956"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21 8.87996C3.32598 8.87996 3.42 8.78594 3.42 8.66996C3.42 8.55398 3.32598 8.45996 3.21 8.45996C3.09402 8.45996 3 8.55398 3 8.66996C3 8.78594 3.09402 8.87996 3.21 8.87996Z",
    fill: "#FFD956"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 4.13C19.627 4.13 19.88 3.87704 19.88 3.565C19.88 3.25296 19.627 3 19.315 3C19.003 3 18.75 3.25296 18.75 3.565C18.75 3.87704 19.003 4.13 19.315 4.13Z",
    fill: "#FFD956"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1995_5864",
    x1: 9.2634,
    y1: 8.86607,
    x2: 14.5595,
    y2: 9.17063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVpnEncrIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vpn-encr-icon.8e98df2f1d56a0249a95ebda0915e624.svg";